/* eslint-disable @typescript-eslint/naming-convention */

const AI_API_ACCESS_TOKEN = '02833eeff87a4462bb0bdcac5f4ff837';
const AI_API_ACCESS_TOKEN_GREY_LABEL = 's3cj7d5d1ff32206ad934ee8ad7155c27';
const AI_API_CALLER_IDS = {
  COMMON_PAYMENT: 'common-payment',
};

export { AI_API_ACCESS_TOKEN, AI_API_ACCESS_TOKEN_GREY_LABEL, AI_API_CALLER_IDS };
